import { useLocation, matchPath } from "react-router-dom";

const usePathPattern = (routes) => {
  const { pathname } = useLocation();
  return routes.find((route) => matchPath(route, pathname));
};

export default usePathPattern;
